<template>

  <div class="elevation-4">
    <v-toolbar flat="flat">
      <v-toolbar-title>Categories</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="700px">
        <v-icon medium="medium" slot="activator">mdi-plus</v-icon>
        <v-card>
          <v-card-title class="headline">{{ dialogTitle }}</v-card-title>
          <v-card-text>
            <v-container fluid="fluid" grid-list-xl="grid-list-xl">
              <v-flex>
                <v-text-field v-model="editedCategory.name" label="Name" placeholder="Name"></v-text-field>
              </v-flex>
              <v-flex>
                <div class="error-message">{{ errorMessage }}</div>
              </v-flex>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat="flat" @click.native="close">Cancel</v-btn>
            <v-btn color="primary" flat="flat" @click.native="save">{{ dialogButton }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table hide-headers="hide-headers" hide-actions="hide-actions" :items="categories" :headers="columns">
      <template slot="items" slot-scope="props">
        <tr>
          <td>
            <CategoryLink :id="props.item.id" :showID="true"></CategoryLink>
          </td>
          <td class="categories-actions">
            <v-icon class="mr-2" title="Edit" @click="edit(props.index)" :disabled="props.item.name === 'default'">mdi-pencil</v-icon>
            <v-icon class="mr-2" title="Delete" @click="del(props.item.id)" :disabled="props.item.name === 'default'">mdi-delete</v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>

</template>

<script>

import CategoryLink from '@/components/links/Category'

export default {
  name: 'FederationCategories',
  components: {
    CategoryLink
  },
  props: ['categories', 'loading', 'federationID'],
  data: () => ({
    dialog: null,
    editedCategory: {
      name: null
    },
    editedIndex: -1,
    errorMessage: '',
    columns: [{
      text: 'Category'
    }, {
      text: 'Action',
      width: '200px'
    }]
  }),
  computed: {
    dialogTitle () {
      return this.editedIndex === -1 ? 'Create a category' : 'Edit a category'
    },

    dialogButton () {
      return this.editedIndex === -1 ? 'Create' : 'Edit'
    }
  },
  methods: {
    del (id) {
      this.$store.dispatch('deleteCategory', id)
        .catch(console.error)
    },

    createCategory () {
      if (!this.editedCategory.name) {
        this.errorMessage = 'You must enter a category name'
        return
      }

      for (const c of this.categories) {
        if (this.editedCategory.name === c.name) {
          this.errorMessage = 'This category already exists'
          return
        }
      }

      this.$store.dispatch('createCategory', {
        federationID: this.federationID,
        category: {
          name: this.editedCategory.name
        }
      })
        .then(() => this.close())
    },

    close () {
      this.dialog = false
      this.editedCategory = {
        name: null
      }
      this.editedIndex = -1
      this.errorMessage = ''
    },

    save () {
      if (this.editedIndex === -1) {
        this.createCategory()
      } else {
        this.editCategory()
      }
    },

    edit (index) {
      this.editedIndex = index
      this.dialog = true
      this.editedCategory.name = this.categories[index].name
    }
  }
}

</script>

<style lang="scss" scoped>

.categories-actions {
  width: 120px;
}

</style>



// WEBPACK FOOTER //
// src/pages/federation/FederationCategories.vue